export default function Footer() {
  return (
    <footer className="footer">
      <p>
        © 2021 leodeslf
      </p>
    </footer>
  );
}
